var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00065 1.66634C4.05484 1.66634 1.66732 4.05386 1.66732 6.99967C1.66732 9.94549 4.05484 12.333 7.00065 12.333C9.94646 12.333 12.334 9.94549 12.334 6.99967C12.334 4.05386 9.94646 1.66634 7.00065 1.66634ZM0.333984 6.99967C0.333984 3.31748 3.31846 0.333008 7.00065 0.333008C10.6828 0.333008 13.6673 3.31748 13.6673 6.99967C13.6673 10.6819 10.6828 13.6663 7.00065 13.6663C3.31846 13.6663 0.333984 10.6819 0.333984 6.99967ZM7.00065 2.33301C7.36884 2.33301 7.66732 2.63148 7.66732 2.99967V6.33301H9.66732C10.0355 6.33301 10.334 6.63148 10.334 6.99967C10.334 7.36786 10.0355 7.66634 9.66732 7.66634H7.00065C6.63246 7.66634 6.33398 7.36786 6.33398 6.99967V2.99967C6.33398 2.63148 6.63246 2.33301 7.00065 2.33301Z",
    fill: "#0269EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/inProgress.6fcde34f296d6bdbbef12dca826e81e4.svg";
export { ForwardRef as ReactComponent };